import React from 'react';
import { Routes, Route, NavLink } from 'react-router-dom';
import {
  ChartBarIcon,
  UsersIcon,
  RectangleStackIcon,
  ServerIcon,
  FlagIcon,
} from '@heroicons/react/24/outline';
import AdminOverview from './tabs/AdminOverview';
import AdminUsers from './tabs/AdminUsers';
import AdminCampaigns from './tabs/AdminCampaigns';
import AdminSystemHealth from './tabs/AdminSystemHealth';
import AdminMiniGolfHoles from './tabs/AdminMiniGolfHoles';

// Absolute paths so NavLink "to" doesn't append to the current admin
// subroute on each click (which previously produced URLs like
// /studio/admin/campaigns/users/users).
const tabs = [
  { path: '/studio/admin',                label: 'Overview',         icon: ChartBarIcon,        end: true },
  { path: '/studio/admin/users',          label: 'Users',            icon: UsersIcon },
  { path: '/studio/admin/campaigns',      label: 'Campaigns',        icon: RectangleStackIcon },
  { path: '/studio/admin/system',         label: 'System',           icon: ServerIcon },
  { path: '/studio/admin/minigolf-holes', label: 'Mini golf holes',  icon: FlagIcon },
];

export default function AdminDashboard() {
  return (
    <div className="gch-content-width gch-page">
      <header className="mb-4 sm:mb-6">
        <h1 className="text-xl font-bold gch-text-accent sm:text-3xl tracking-tight">
          Admin Dashboard
        </h1>
        <p className="mt-1 text-sm gch-text-secondary">
          Platform management and usage tracking.
        </p>
      </header>

      {/* Tab Navigation */}
      <nav className="flex gap-1 mb-6 overflow-x-auto pb-1 -mx-1 px-1 scrollbar-hide">
        {tabs.map(({ path, label, icon: Icon, end }) => (
          <NavLink
            key={path}
            to={path}
            end={end}
            className={({ isActive }) =>
              `flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-all duration-200 ${
                isActive
                  ? 'bg-white/10 text-white ring-1 ring-inset ring-white/20'
                  : 'gch-text-secondary hover:text-white hover:bg-white/5'
              }`
            }
          >
            <Icon className="w-4 h-4 shrink-0" />
            {label}
          </NavLink>
        ))}
      </nav>

      {/* Tab Content */}
      <Routes>
        <Route index element={<AdminOverview />} />
        <Route path="users" element={<AdminUsers />} />
        <Route path="campaigns" element={<AdminCampaigns />} />
        <Route path="system" element={<AdminSystemHealth />} />
        <Route path="minigolf-holes" element={<AdminMiniGolfHoles />} />
      </Routes>
    </div>
  );
}
